import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

const SqftSummaryBacksplashes = (props) => {
  const {measureUnit, intl} = props;
  const {backsplashes} = props;
  let messageTotal,
    backsplashName;

  return (
    backsplashes.map((backsplash, index) => {
      switch(measureUnit) {
        case "Metric":
          messageTotal = "Total : "+ Math.ceil10(backsplash.length, -2) + " m²";
          backsplashName = backsplash.name ? backsplash.name.replace(/"/g, "&quot;") : intl.formatMessage({id: "sqft.navigation.submenu.backsplash"});
          break;
        case "Imperial":
        default:
          messageTotal = intl.formatMessage({id: "sqft.navigation.summary.shapesTotal"}) + " " + Math.ceil(backsplash.length) +"\'";
          backsplashName = backsplash.name ? backsplash.name.replace(/"/g, "&quot;") : intl.formatMessage({id: "sqft.navigation.submenu.backsplash"});
      }

      return (
        <div className="summary-list__item summary summary--blue" key={index}>
          <div className="summary-title">
            { backsplashName }
          </div>
          <div className="summary-info">
            <div className="summary-info__left">
              <FormattedMessage id="sqft.navigation.summary.segments"/>: {backsplash.segments}
            </div>
            <div className="summary-info__right">{messageTotal}</div>
          </div>
        </div>
      )
    })
  )
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton,
  measureUnit: store.sqftState.measureUnit
});

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftSummaryBacksplashes)
);
